import { IDType } from '@core/models/types';
import { IUser } from '@core/user';
import { WizardBasket } from '@wizard/models';
import { createEmptyWizardBasketData } from './create-empty-wizard-basket-data';

export const createWizardBasket = (name: string, user: IUser, refAndVer: { referentialId: IDType, versionId: IDType; }): WizardBasket => {
  // !keep this order, so helper 'basketsAreDifferent' check name first (i.e. before updateDate)
  return {
    id: null,
    status: null,
    name,
    user,
    creationDate: new Date().toISOString(),
    updateDate: null,
    documents: null,
    specification: null,
    data: createEmptyWizardBasketData(),
    bwMigration: false,
    ...refAndVer
  };
};
